import React from "react";
import styled from "styled-components";

export interface ChipType {
  label: string;
  action: string;
  tooltip?: string;
  params?: Record<string, any>;
}

const ChipContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 8px 0 10px 10px;
  justify-content: flex-start;
`;

const Chip = styled.button`
  background-color: var(--surface-color);
  border: 1px solid var(--accent-warm);
  color: var(--accent-warm);
  padding: 6px 12px;
  border-radius: 16px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: var(--accent-warm);
    color: white;
  }
`;

interface ChipListProps {
  chips: ChipType[];
  onChipClick: (chip: ChipType) => void;
}

const ChipList: React.FC<ChipListProps> = ({ chips, onChipClick }) => (
  <ChipContainer>
    {chips.map((chip, index) => (
      <Chip
        key={index}
        onClick={() => onChipClick(chip)}
        title={chip.tooltip || chip.action || chip.label} // use tooltip if available
      >
        {chip.label}
      </Chip>
    ))}
  </ChipContainer>
);

export default ChipList;
